import React from "react";

import RichText from "components/RichText";
import { classNames } from "utils";

import * as styles from "../styles.module.less";

export function SimplePageTemplate({ title, body }) {
  return (
    <article
      className={classNames(styles.regularContainer, styles.whiteBackground)}
    >
      <div>
        <header>
          <h1>{title}</h1>
        </header>
        <RichText html={body} />
      </div>
    </article>
  );
}
